import {emailSvg as Icon__small__emailSvg} from '../Icon__small/Icon__small--email.js'

export var email = {
  name: 'email',
  category: 'icon',
  colorable: true,
  svg: Icon__small__emailSvg,
};
